import { combineReducers } from 'redux';
import loggedUser from './loggedUser';
import config from './config';
import notifications from './notifications';

export default combineReducers({
    loggedUser,
    config,
    notifications,
});